module.exports = __webpack_public_path__ + "static/media/wtd.ae6142c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wtd.png
// module id = 6836
// module chunks = 2